// © 2015-2021 WDNA - All Rights Reserved
import _ from 'lodash';
import { Store } from 'redux';

import { UserDO } from 'wdna-components';

import { items as adminItems } from '../../../config/navigation/navigation.adm.json';
import { items as clientItems } from '../../../config/navigation/navigation.cli.json';

const LOCATION_CHANGE: string = '@@router/LOCATION_CHANGE';

/**
 * Perform a deep search in the list of permissions of a route
 *
 * @param items items of the permissions
 * @returns permission list of the deep search
 */
function deepSearchForRoutes(items: any[]): Set<any> {
  const routes: Set<any> = new Set<any>();
  if (!items || !items.length) return routes;

  // TODO: review ??
  const stack: any[][] = [items];
  while (stack.length) {
    const stackObject: any[] = stack.pop() || [];
    stackObject.forEach((item: any) => {
      if (item.items) stack.push(item.items);
      if (item.route) routes.add(item.route);
    });
  }

  return routes;
}

/**
 * Checks if a route access is allowed to a user
 *
 * @param route route to check access
 * @param userType user to check access
 * @returns true if user has access to the route false otherwise
 */
export function isRouteAllowedToUser(route: string, userType: string): boolean {
  if (!route || !userType) return false;
  if (userType === 'adm') return true;
  const userItems: any[] = (userType === 'adm') ? adminItems : clientItems;
  const adminRoutes: Set<any> = deepSearchForRoutes(adminItems);
  const userRoutes: Set<any> = deepSearchForRoutes(userItems);

  const disallowedRoutes: Set<any> = new Set([...adminRoutes].filter((r: any) => !userRoutes.has(r)));

  const routeIsAllowed: boolean = !disallowedRoutes.has(route);
  return routeIsAllowed;
}

/**
 * Return action to redirec to error 404 page of the application
 *
 * @returns the objecto to performa the redirection
 */
export function redirectTo404Page(): any {
  return {
    type: LOCATION_CHANGE,
    payload: {
      action: 'POP',
      location: { pathname: '/404/main', search: '', hash: '', state: undefined },
    },
  };
}

/**
 * Returns the permission middleware function
 *
 * @param store system store to get state
 * @returns middleware function process
 */
export function permissionMiddleware(store: Store): any {
  return (next: ((a: any) => any)) => (action: any): any => {
    const { type, payload } = action;
    if (type === LOCATION_CHANGE) {
      const user: UserDO = _.get(store.getState(), ['user', 'user']);
      const userType: string = (user && user.type) || 'cli';
      const { pathname } = payload.location;

      if (!userType || !pathname) return null;

      if (!isRouteAllowedToUser(pathname, userType)) {
        store.dispatch(redirectTo404Page());
        return null;
      }
    }

    return next(action);
  };
}
